import { useLazyQuery } from "@apollo/client";

import { GET_STAND_COMMENT } from "graphql/query/stand-gql";


const useLazyQueryStandComment = () => {
    const [ loadComment, { data, loading } ] = useLazyQuery(GET_STAND_COMMENT, {
        fetchPolicy: "network-only",
    });

    return {
        _loadStandComment: loadComment,
        dataStandComment: data?.comment,
        loadingLazyQueryStandComment: loading,
    };
};

export default useLazyQueryStandComment;
